import { useState } from 'react'
import useRouteChange from '@/presentation/hooks/navigate/use-route-change'

/**
 * Tracks the active tab value based on the current route.
 * Fires on mount and on every route change.
 *
 * @param resolver - Pure function that maps a pathname to a tab value (or false for no selection)
 */
export function useActiveTab(resolver: (pathname: string) => string | false): string | false {
  const [value, setValue] = useState<string | false>(false)
  useRouteChange(pathname => setValue(resolver(pathname)))
  return value
}
